import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Text Align Icons
// Use boxSize prop to control size at the usage site.
// =============================================================================

export function TextAlignLeft(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TextAlignLeft",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="17"
          y1="10"
          x2="3"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="6"
          x2="3"
          y2="6"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="14"
          x2="3"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="17"
          y1="18"
          x2="3"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TextAlignCenter(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TextAlignCenter",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="18"
          y1="10"
          x2="6"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="6"
          x2="3"
          y2="6"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="14"
          x2="3"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="18"
          y1="18"
          x2="6"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TextAlignRight(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TextAlignRight",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="21"
          y1="10"
          x2="7"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="6"
          x2="3"
          y2="6"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="14"
          x2="3"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="18"
          x2="7"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TextAlignJustify(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TextAlignJustify",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="21"
          y1="10"
          x2="3"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="6"
          x2="3"
          y2="6"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="14"
          x2="3"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="18"
          x2="3"
          y2="18"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
